import React from "react";
import TableSortHeader from "../components/TableSortHeader";

export const tableSortStyles = {
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  sortCell: {
    "&:hover $sortButtons": {
      opacity: 1,
      visibility: "visible",
      pointerEvents: "auto",
    },
  },
  sortCellActive: {
    "& $sortButtons": {
      opacity: 1,
      visibility: "visible",
      pointerEvents: "auto",
    },
  },
  sortButtons: {
    display: "inline-flex",
    opacity: 0,
    visibility: "hidden",
    pointerEvents: "none",
    transition: "opacity 0.15s ease-in-out",
  },
};

export function getNextSortState(orderBy, order, keyName) {
  const state = {
    orderBy: keyName,
    order,
  };

  if (state.orderBy !== orderBy) {
    state.order = null;
  }

  if (state.order === null) {
    state.order = "asc";
  } else if (state.order === "asc") {
    state.order = "desc";
  } else if (state.order === "desc") {
    state.order = null;
    state.orderBy = null;
  }

  return state;
}

export function bindTableSortHandlers(component, options = {}) {
  const { afterSortChange } = options;

  const setSortState = function (state) {
    if (afterSortChange) {
      this.setState(state, afterSortChange);
    } else {
      this.setState(state);
    }
  };

  component.changeSort = function (event) {
    const keyName = event.currentTarget.dataset.key;
    setSortState.call(this, getNextSortState(this.state.orderBy, this.state.order, keyName));
  }.bind(component);

  component.sortAscending = function (keyName) {
    setSortState.call(this, {
      orderBy: keyName,
      order: "asc",
    });
  }.bind(component);

  component.sortDescending = function (keyName) {
    setSortState.call(this, {
      orderBy: keyName,
      order: "desc",
    });
  }.bind(component);

  component.makeSortLabel = function (keyName, viewName) {
    const { classes } = this.props;

    return (
      <TableSortHeader
        keyName={keyName}
        viewName={viewName}
        orderBy={this.state.orderBy}
        order={this.state.order}
        onCycleSort={this.changeSort}
        onSortAsc={() => this.sortAscending(keyName)}
        onSortDesc={() => this.sortDescending(keyName)}
        classes={classes}
      />
    );
  }.bind(component);

  component.makeCellSortProps = function (keyName) {
    const isActive = this.state.orderBy === keyName;
    const { classes } = this.props;

    return {
      key: keyName,
      align: "left",
      padding: "normal",
      sortDirection: isActive ? this.state.order : false,
      className: isActive ? classes.sortCellActive : classes.sortCell,
    };
  }.bind(component);
}
